import React from "react";
import ClientBankGenericSkeleton from "./ClientBankGenericSkeleton";

function ClientBankDetailSkeleton() {
  return (
    <>
      <ClientBankGenericSkeleton />
    </>
  );
}

export default ClientBankDetailSkeleton;
